import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { GxOption } from "../../../../../components";

export const changesetToComboBoxModel = (
  changesetModel: GxOption[]
): ComboBoxModel => {
  if (!changesetModel) return [];

  return changesetModel.map(changeset => ({
    value: changeset.id,
    caption:
      changeset.name === "All"
        ? "All Changesets"
        : changeset.label || changeset.name || ""
  }));
};
